module.exports = __webpack_public_path__ + "be5712a19edfe171f29c1f5ceaaa5fa2.MP3";